const DEFAULT_UNIT = 'scs';

const CROPTYPE_UNIT = new Map([
  ['SOY', 'scs'],
  ['CORN', 'scs'],
  ['WINTER_CORN', 'scs'],
  ['COFFEE', 'scs'],
  ['SUGARCANE', 't' ],
  ['COTTON', 'arrobas' ],
]);

export const formattedYield = (value: number, cropType: string) => {
  const unit = CROPTYPE_UNIT.get(cropType) ?? DEFAULT_UNIT;
  const convertedValue = Number(value);
  return (
    (convertedValue &&
      `${convertedValue.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })} ${unit}/ha`) ||
    `0.00 ${unit}/ha`
  )
}


export const formattedProduction = (value: number, cropType: string) => {
  const unit = CROPTYPE_UNIT.get(cropType) ?? DEFAULT_UNIT;
  const convertedValue = Number(value);
  return (
    (convertedValue &&
      `${convertedValue.toLocaleString(undefined, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      })} ${unit}`) ||
    `0${unit}`
  )
}
